module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Incoming-call-ab186d187e3470b3a4d2c93f8b08866d.svg";